import * as C from './styles';


export const Logo = () => {
    return (
        <C.Container>
            <C.Title>Jogo da Mémoria</C.Title>
            <C.SubTitle>Equipes do ECC</C.SubTitle>
        </C.Container>
    );
}